import _regeneratorRuntime from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array.find.js";
import { getPowerRevenueApi } from '@/api';
import { dbDataHandle } from '@/store/function/common/index';

import downloadCsv from 'download-csv';
export default {
  name: 'PowerGenerationRevenue',
  props: {
    filename: {
      type: String,
      default: '下載檔案'
    }
  },
  data: function data() {
    return {
      hasNoData: false,
      etodayData: [],
      tableField: [{
        key: 'date',
        label: '月份'
      }, {
        key: 'revenueGoal',
        label: '目標發電收入 (NTD)'
      }, {
        key: 'revenueActual',
        label: '實際發電收入 (NTD)'
      }, {
        key: 'irrGoal',
        label: '目標日照量 (kWh/m²)'
      }, {
        key: 'irrActual',
        label: '實際日照量 (kWh/m²)'
      }, {
        key: 'accAcpAll',
        label: '累計發電量 (kWh)'
      }],
      dataClassArr: ['發電收入', '日照量', '實際累積發電量'],
      dataClass: ['發電收入', '日照量', '實際累積發電量'],
      revenueChart: {
        chart: {
          height: 350,
          backgroundColor: null,
          events: {
            load: function load() {
              this.showLoading();
            }
          }
        },
        credits: {
          enabled: false
        },
        title: {
          text: ''
        },
        xAxis: {
          categories: []
        },
        plotOptions: {
          series: {
            dataLabels: {
              enabled: true
            }
          }
        },
        legend: {
          layout: 'horizontal',
          align: 'center',
          verticalAlign: 'top',
          floating: false
        },
        yAxis: [{
          title: {
            text: '發電收入 (NTD)'
          }
        }, {
          title: {
            text: '日照量 (kWh/m²)'
          },
          opposite: true
        }, {
          title: {
            text: '累計發電量 (kWh)'
          },
          opposite: true
        }],
        tooltip: {
          shared: true
        },
        series: [{
          color: 'rgb(255, 192, 0)',
          type: 'column',
          name: '目標發電收入 (NTD)',
          data: [60000, 60000, 60000, 60000, 60000, 60000, 60000, 60000, 60000, 62000, 62000, 62000],
          yAxis: 0,
          visible: true
        }, {
          color: 'rgb(124,181,236)',
          type: 'column',
          name: '實際發電收入 (NTD)',
          data: [50000, 50000, 50000, 50000, 50000, 50000, 50000, 50000, 50000],
          yAxis: 0,
          visible: true
        }, {
          color: 'rgb(155, 102, 196)',
          name: '目標日照量 (kWh/m²)',
          data: [110, 110, 110, 110, 110, 110, 110, 110, 110, 110, 110, 110],
          yAxis: 1,
          visible: true
        }, {
          color: 'rgb(230, 101, 146)',
          name: '實際日照量 (kWh/m²)',
          data: [100, 80, 100, 80, 90, 100, 100, 100, 100],
          yAxis: 1,
          visible: true
        }, {
          color: 'rgb(37, 84, 128)',
          name: '實際累積發電量 (kWh)',
          data: [650000, 700000, 750000, 800000, 850000, 900000, 950000, 1000000, 1050000],
          yAxis: 2,
          visible: true
        }],
        responsive: {
          rules: [{
            condition: {
              maxWidth: 500
            },
            chartOptions: {
              legend: {
                layout: 'horizontal',
                align: 'center',
                verticalAlign: 'bottom',
                y: 0
              }
            }
          }]
        }
      },
      etodayDataForExcel: []
    };
  },
  methods: {
    getEtodayData: function getEtodayData(months) {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var _etodayData$data, etodayData;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.revenueChart.series.forEach(function (x) {
                  x.data = [];
                });
                _context.prev = 1;
                _context.next = 4;
                return getPowerRevenueApi(_this.$route.query.fid, _this.$route.query.siteName + '.json', months);
              case 4:
                etodayData = _context.sent;
                if (etodayData !== null && etodayData !== void 0 && (_etodayData$data = etodayData.data) !== null && _etodayData$data !== void 0 && _etodayData$data.success) {
                  // 複製 etodayData、etodayDataForExcel 不能 refer 同個 data
                  // renderData() 會改動 etodayData 資料

                  // 下載資料用
                  _this.etodayDataForExcel = etodayData.data.data;

                  // 顯示圖表、表格用，copy 避免改動到 rawData (etodayData.data.data)
                  _this.etodayData = etodayData.data.data.map(function (item) {
                    var copy = Object.assign({}, item);
                    return copy;
                  });
                  _this.renderData();
                  _this.hasNoData = false;
                }
                _context.next = 13;
                break;
              case 8:
                _context.prev = 8;
                _context.t0 = _context["catch"](1);
                console.log('getEtodayData error: ', _context.t0);
                _this.hasNoData = true;
                _context.t0.msg && _this.$swal(_context.t0.msg);
              case 13:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[1, 8]]);
      }))();
    },
    renderData: function renderData() {
      var _this2 = this;
      this.revenueChart.xAxis.categories = [];
      this.revenueChart.series.forEach(function (x) {
        x.data = [];
      });
      this.etodayData.forEach(function (x) {
        _this2.revenueChart.xAxis.categories.push(x.date);
        // 圖表、表格 是共用 this.etodayData 資料，直接 dbDataHandle 改變原始資料，顯示處理過的數據
        x.revenueGoal = x.revenueGoal === null ? null : dbDataHandle(x.revenueGoal);
        x.revenueActual = x.revenueActual === null ? null : dbDataHandle(x.revenueActual);
        x.irrGoal = x.irrGoal === null ? null : dbDataHandle(x.irrGoal);
        x.irrActual = x.irrActual === null ? null : dbDataHandle(x.irrActual);
        x.accAcpAll = x.accAcpAll === null ? null : dbDataHandle(x.accAcpAll);
        _this2.revenueChart.series[0].data.push(x.revenueGoal);
        _this2.revenueChart.series[1].data.push(x.revenueActual);
        _this2.revenueChart.series[2].data.push(x.irrGoal);
        _this2.revenueChart.series[3].data.push(x.irrActual);
        _this2.revenueChart.series[4].data.push(x.accAcpAll);
      });
      this.hideHighChartLoading();
    },
    hideHighChartLoading: function hideHighChartLoading() {
      this.$nextTick(function () {
        if (this.$refs && this.$refs.chart) {
          this.$refs.chart.chart.hideLoading();
          this.revenueChart.chart.events = {};
        }
      });
    },
    downloadAnalysis: function downloadAnalysis() {
      var downloadArr = [];
      var fields = ['name'];
      fields = fields.concat(this.revenueChart.xAxis.categories);
      this.revenueChart.series.forEach(function (x) {
        downloadArr.push({
          name: x.name
        });
      });
      var download = [];
      this.revenueChart.series.forEach(function (_) {
        download.push({
          data: []
        });
      });
      this.etodayDataForExcel.forEach(function (obj) {
        var revenueGoal = obj.revenueGoal === null ? null : obj.revenueGoal;
        var revenueActual = obj.revenueActual === null ? null : obj.revenueActual;
        var irrGoal = obj.irrGoal === null ? null : obj.irrGoal;
        var irrActual = obj.irrActual === null ? null : obj.irrActual;
        var accAcpAll = obj.accAcpAll === null ? null : obj.accAcpAll;
        download[0].data.push(revenueGoal);
        download[1].data.push(revenueActual);
        download[2].data.push(irrGoal);
        download[3].data.push(irrActual);
        download[4].data.push(accAcpAll);
      });
      this.revenueChart.xAxis.categories.forEach(function (x, xindex) {
        downloadArr.forEach(function (y, yindex) {
          y["".concat(x)] = download[yindex].data[xindex];
        });
      });
      downloadCsv(downloadArr, fields, this.filename);
    }
  },
  watch: {
    dataClassArr: function dataClassArr(newValue, oldValue) {
      var _this3 = this;
      var setData = [{
        name: '發電收入',
        dataName: ['目標發電收入 (NTD)', '實際發電收入 (NTD)']
      }, {
        name: '日照量',
        dataName: ['目標日照量 (kWh/m²)', '實際日照量 (kWh/m²)']
      }, {
        name: '實際累積發電量',
        dataName: ['實際累積發電量 (kWh)']
      }];
      if (oldValue !== newValue) {
        this.revenueChart.series.forEach(function (x) {
          x.visible = false;
        });
        setData.forEach(function (x) {
          if (newValue.includes(x.name)) {
            x.dataName.forEach(function (y) {
              _this3.revenueChart.series.find(function (z) {
                return z.name === y;
              }).visible = true;
            });
          }
        });
      }
    }
  }
};